import { ComponentPropsWithoutRef } from 'react'
import { twMerge } from 'tailwind-merge'

interface Props extends ComponentPropsWithoutRef<'div'> {}

export const CardShell = ({ className, children, ...props }: Props) => {
  return (
    <div
      className={twMerge('w-full flex flex-col gap-4 p-3 border border-border-quiet', className)}
      {...props}
    >
      {children}
    </div>
  )
}
